import type { PropsWithChildren } from 'react';
import React from 'react';
import { RelayEnvironmentProvider } from 'react-relay';
import { createRelayEnvironment } from '@atlassian/relay-environment/createRelayEnvironment';

import { CompanyHubPageLayout } from '@confluence/page-layout/entry-points/CompanyHubPageLayout.ts';
import { expValEquals } from '@confluence/feature-experiments';
import { getRelayEnvironment } from '@confluence/graphql-provider/entry-points/relayEnvironment.ts';
import { fg } from '@confluence/feature-gating';

const relayEnvironment = createRelayEnvironment({});

/**
 * The {@link https://staging.atlassian.design/components/navigation-system/page-layout | page layout} of the Company Hub app-like experience at Team '25 US.
 *
 * Inspired by `MainLayout` at confluence/next/packages/main-layout/src/MainLayout.tsx and `MainLayoutComponent`.
 *
 * @see {@link https://www.figma.com/design/MBdUXhdmgbsIkMkOhQGu5e/Hub-App?node-id=101-52260}
 * @see {@link https://hello.atlassian.net/wiki/spaces/CLI/pages/4856024337/Confluence-less+Team+25+US+Experience}
 */
export const CompanyHubMainLayout = ({ children }: CompanyHubMainLayoutProps) => {
	const content = <CompanyHubPageLayout>{children}</CompanyHubPageLayout>;

	return expValEquals('confluence_preview_panels_exp', 'isEnabled', true) ||
		fg('navx-global-side-nav-confluence') ? (
		<RelayEnvironmentProvider
			environment={fg('cfe_use_confluence_relay_env') ? getRelayEnvironment() : relayEnvironment}
		>
			{content}
		</RelayEnvironmentProvider>
	) : (
		content
	);
};

type CompanyHubMainLayoutProps = PropsWithChildren<{}>;
